export const LOGIN_PATH = '/login/';
export const SETTING_PATH = '/setting/';
export const SUBJECT_PATH = '/subjects/';
export const SELECT_PATH = '/subjects/select/';
export const INSTRUCTION_PATH = '/subjects/instruction/';
export const MEASUREMENT_PATH = '/subjects/measurement/';
export const EXPLANATION_PATH = '/subjects/select/explanation/';
export const ORAL_FRAILTY_PATH = '/subjects/select/oral-frailty/'
export const REPORT_DATA_PATH = '/subjects/select/report/'
export const RESULT_PATH = '/subjects/select/result/';
export const INSPECTION_PATH = '/inspection/';
export const HISTORY_PATH = '/history/';
export const HISTORYDATE_PATH = '/historydate/';
export const REPORT_PATH = '/report/';  //※廃止予定
export const UPLOAD_S3_PATH = '/upload-to-s3/';
export const UPLOAD_CSV_S3_PATH = '/upload-csv-to-s3/'
export const GET_S3_PATH = '/get-from-s3/';
export const PDF_PATH = '/convertPDF/';
export const PDF_S3_PATH = 'pataka_data/pdf_data/';

// export const BASE_URL = 'https://poc-api-pataka.lion-apps.jp/api/operators';
// export const INVOCATION_URL = 'https://poc-api-pataka.lion-apps.jp/invocations';
export const BASE_URL = '/api/operators';
export const INVOCATION_URL = '/invocations';
export const LOGIN_URL = `${BASE_URL}${LOGIN_PATH}`;
export const SETTING_URL = `${BASE_URL}${SETTING_PATH}`;
export const SUBJECT_URL = `${BASE_URL}${SUBJECT_PATH}`;
export const SELECT_URL = `${BASE_URL}${SELECT_PATH}`;
export const INSTRUCTION_URL = `${BASE_URL}${INSTRUCTION_PATH}`;
export const MEASUREMENT_URL = `${BASE_URL}${MEASUREMENT_PATH}`;
export const EXPLANATION_URL = `${BASE_URL}${EXPLANATION_PATH}`;
export const ORAL_FRAILTY_EXPLANATION_URL = `${BASE_URL}${ORAL_FRAILTY_PATH}`;
export const REPORT_DATA_URL = `${BASE_URL}${REPORT_DATA_PATH}`;
export const RESULT_URL = `${BASE_URL}${RESULT_PATH}`;
export const INSPECTION_URL = `${BASE_URL}${INSPECTION_PATH}`;
export const HISTORY_URL = `${BASE_URL}${HISTORY_PATH}`;
export const HISTORYDATE_URL = `${BASE_URL}${HISTORYDATE_PATH}`;
export const REPORT_URL = `${BASE_URL}${REPORT_PATH}`;  //※廃止予定
export const UPLOAD_S3_URL = `${BASE_URL}${UPLOAD_S3_PATH}`;
export const UPLOAD_CSV_S3_URL = `${BASE_URL}${UPLOAD_CSV_S3_PATH}`;
export const GET_S3_URL = `${BASE_URL}${GET_S3_PATH}`;
export const PDF_URL = `${BASE_URL}${PDF_PATH}`;

